export default __webpack_public_path__ + "static/media/brandarrows-background-image-trans.c1c9b233.png";